import {Component, OnInit} from '@angular/core';
import {PageEvent} from '@angular/material/paginator';
import {Sort} from '@angular/material/sort';
import {saveAs} from 'file-saver';
import {ReportOverViewDTO} from '../../../../model/reportOverViewDTO';
import {ReportService} from '../../../../services/report.service';
import {NotificationService} from '../../../../services/notification.service';
import {serialize} from 'v8';

@Component({
  templateUrl: './report-overview.component.html',
})
export class ReportOverviewComponent implements OnInit {

  content: ReportOverViewDTO[] = [];
  totalElements = 0;
  sort;

  pageSize = 1000;
  pageSizeOptions: number[] = [25, 50, 100, 250, 500, 1000];
  pageEvent: PageEvent = new PageEvent(); // MatPaginator Output


  constructor(private reportService: ReportService,
              private notificationService: NotificationService) {
  }

  ngOnInit() {
    this.sort = {column: 'createdAt', dir: 'desc'};
    this.pageEvent.pageIndex = 0;
    this.pageEvent.pageSize = this.pageSize;
    this.getPage();
  }

  updatePage($event) {
    this.pageEvent = $event;
    this.getPage();
    return $event;
  }

  getPage() {
    this.reportService.getAll(this.pageEvent.pageIndex, this.pageEvent.pageSize, this.sort.column, this.sort.dir).subscribe(page => {
      this.content = page.content;
      this.totalElements = page.totalElements;
    });
  }

  sortPage($event: Sort) {
    this.sort.column = $event.active;
    this.sort.dir = $event.direction;
    this.getPage();
  }

  download(row: any) {
    this.reportService.downloadFinishedReport(row.finishedReport.id).subscribe((data) => {
      saveAs(data, 'rapport.pdf');
      this.notificationService.success('rapport gedownload');
    });
  }

  generateReportsNewYear() {
      this.notificationService.confirm({header: 'hiermee worden de nieuwe rekening en verantwoordingen voor alle actieve bewinden toegevoed'}).then(() => {
        this.reportService.generateReportsNewYear().subscribe(
          () => this.notificationService.success(),
          error => this.notificationService.errorResponse(error));
      });
  }
}
